/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DefaultConfigurationResponseV2 } from '../api-models';
/**
 * ConfigurationsV2Api - axios parameter creator
 * @export
 */
export const ConfigurationsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the facility-level default values used by the Employee Center  bootstrap — default PayType / Shift / PayPeriodGroup, the four default  schedule-status-types, the default StateName, and the legacy  `LastConsideredHiredStatusIsConsideredHireDate` flag. Replaces TaAPI  `GET /api/Configurations/Defaults`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigurationsDefaultsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/configurations/defaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationsV2Api - functional programming interface
 * @export
 */
export const ConfigurationsV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationsV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the facility-level default values used by the Employee Center  bootstrap — default PayType / Shift / PayPeriodGroup, the four default  schedule-status-types, the default StateName, and the legacy  `LastConsideredHiredStatusIsConsideredHireDate` flag. Replaces TaAPI  `GET /api/Configurations/Defaults`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigurationsDefaultsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ConfigurationsDefaultsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigurationsV2Api - factory interface
 * @export
 */
export const ConfigurationsV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationsV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the facility-level default values used by the Employee Center  bootstrap — default PayType / Shift / PayPeriodGroup, the four default  schedule-status-types, the default StateName, and the legacy  `LastConsideredHiredStatusIsConsideredHireDate` flag. Replaces TaAPI  `GET /api/Configurations/Defaults`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigurationsDefaultsGet(options?: AxiosRequestConfig): AxiosPromise<DefaultConfigurationResponseV2> {
            return localVarFp.apiV2ConfigurationsDefaultsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationsV2Api - object-oriented interface
 * @export
 * @class ConfigurationsV2Api
 * @extends {BaseAPI}
 */
export class ConfigurationsV2Api extends BaseAPI {
    /**
     * 
     * @summary Returns the facility-level default values used by the Employee Center  bootstrap — default PayType / Shift / PayPeriodGroup, the four default  schedule-status-types, the default StateName, and the legacy  `LastConsideredHiredStatusIsConsideredHireDate` flag. Replaces TaAPI  `GET /api/Configurations/Defaults`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsV2Api
     */
    public apiV2ConfigurationsDefaultsGet(options?: AxiosRequestConfig) {
        return ConfigurationsV2ApiFp(this.configuration).apiV2ConfigurationsDefaultsGet(options).then((request) => request(this.axios, this.basePath));
    }
}
